<div class="tag-wrapper" 
     [ngClass]="{
       'tag-inactive': disabled, 
       'tag-selected': selected, 
       'tag-fill': mode === 'fill', 
       'tag-outline': mode === 'outline', 
       'tag-active': !disabled && !selected
     }"
     role="button"
     [attr.aria-disabled]="disabled"
     [attr.aria-selected]="selected">
  <div class="tag">
    <hyperkit-icon *ngIf="icon" [icon]="icon" size="small"></hyperkit-icon>
    <ng-container *ngIf="textLeft">
      <hyperkit-typography class="static-left" variant="label2" color="inherit">{{ textLeft }}</hyperkit-typography>
    </ng-container>
    <hyperkit-typography class="tag-text" variant="label2" color="inherit">{{ text }}</hyperkit-typography>
    <ng-container *ngIf="operation">
      <hyperkit-typography class="operation" variant="label2" color="inherit">{{ operation }}</hyperkit-typography>
    </ng-container>
    <ng-container *ngIf="textRight">
      <hyperkit-typography class="static-right" variant="label2" color="inherit">{{ textRight }}</hyperkit-typography>
    </ng-container>
    <hyperkit-icon *ngIf="closable" (click)="emitOnClose($event)" class="close-icon" icon="x" size="small" color="inherit" aria-label="Close"></hyperkit-icon>
  </div>
</div>